import { useCurrentReturnRequestHasNothingToHandle } from "@/pages/(app)/returns/refund/hooks/use-line-items-list-sections";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";
import useTranslation from "@babackapp/translations/use-translation";
import { CheckCheck } from "lucide-react";
import { useViewerHasAtLeastCustomerSupportRights } from "@/lib/rights/use-viewer-has-right";

export function useValidateAction(onClick: () => void) {
  const t = useTranslation();
  const returnRequest = useCurrentReturnRequest();
  const approvedAlready = returnRequest.status.approved.done;
  const nothingToValidate = useCurrentReturnRequestHasNothingToHandle();
  const hasCustomerSupportRight = useViewerHasAtLeastCustomerSupportRights();
  const isReturnRequestInError = returnRequest.status.error.done;
  const isCancelled = returnRequest.status.cancelled.done;

  return {
    label: hasCustomerSupportRight
      ? t("returnDetail.refundAndExchange")
      : t("returnDetail.validateArticle"),
    icon: <CheckCheck className="h-5 w-5 text-gray-400" />,
    description: "Valider un ou plusieurs items",
    enabled:
      approvedAlready &&
      !nothingToValidate &&
      !isReturnRequestInError &&
      !isCancelled,
    onClick,
  };
}
